import { rates } from './config';
import { PremieVolksverzekeringenConfig } from './model';

export class PremieVolksverzekeringen {
    
    tax: number;
    
    constructor(data: PremieVolksverzekeringenConfig) {
        const { premieAOW, premieAnw, premieWlz, to } = rates[data.year];
        let percentage = premieAnw + premieWlz;

        if (!data.senior) {
            percentage += premieAOW;
        }

        const maximum = Math.min(to, data.income);
        this.tax = Math.floor(percentage/100 * maximum);;
    }
    
}
